<!--
* @Name：定价方式审批基本页面
* @Author: 王超
* @Date: 2025-09-17 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-09-17 10:39:49
-->
<template>
  <div>
    <hi-cell title="申请单号：" :value="headInfo.applyCode"></hi-cell>
    <hi-cell title="申请人：" :value="headInfo.crtUserName"></hi-cell>
    <hi-cell title="申请日期：" :value="headInfo.crtTime"></hi-cell>
    <hi-cell title="申请标题：" :value="headInfo.applyTitle"></hi-cell>
    <hi-cell title="采购组织：" :value="headInfo.purorgName"></hi-cell>
    <hi-cell title="供货品类：" :value="headInfo.catgName"></hi-cell>
    <hi-cell title="备注：" :value="headInfo.remark"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
